import store from '../store';

export default async function entryCompanyReport({ next, router }) {

    store.commit('SET_PRODUCT_TYPE', 'EntryCompanyReport');

    if (store.getters.isAuthenticated)
        return router.push({ name: "CreateReportFormat", params: { report: 'company' } });
    else
        return router.push({ name: "Login" });

    return next();
}
